module.exports = __webpack_public_path__ + "static/media/prapti.b713ce56.jpg";